/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalIntegration
 */
export interface PalIntegration {
    /**
     * 
     * @type {string}
     * @memberof PalIntegration
     */
    name: PalIntegrationNameEnum;
    /**
     * 
     * @type {string}
     * @memberof PalIntegration
     */
    status: PalIntegrationStatusEnum;
}


/**
 * @export
 */
export const PalIntegrationNameEnum = {
    Availity: 'Availity',
    NaviHealth: 'naviHealth',
    UnitedHealthcare: 'UnitedHealthcare'
} as const;
export type PalIntegrationNameEnum = typeof PalIntegrationNameEnum[keyof typeof PalIntegrationNameEnum];

/**
 * @export
 */
export const PalIntegrationStatusEnum = {
    Complete: 'complete',
    Disabled: 'disabled'
} as const;
export type PalIntegrationStatusEnum = typeof PalIntegrationStatusEnum[keyof typeof PalIntegrationStatusEnum];


/**
 * Check if a given object implements the PalIntegration interface.
 */
export function instanceOfPalIntegration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function PalIntegrationFromJSON(json: any): PalIntegration {
    return PalIntegrationFromJSONTyped(json, false);
}

export function PalIntegrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalIntegration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'status': json['status'],
    };
}

export function PalIntegrationToJSON(value?: PalIntegration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'status': value.status,
    };
}

